import { extendTheme } from "@chakra-ui/react"

export const theme = extendTheme({
  config: {
    useSystemColorMode: false,
  },

  initialColorMode: "light",

  shadows: {
    outline: "none",
  },

  // override default popper zindex (10)
  components: {
    Popover: {
      baseStyle: {
        popper: {
          zIndex: 100,
        },
      },
    },
  },

  colors: {
    brown: {
      50: "#feefe7",
      100: "#e6d3cc",
      200: "#d0b8ae",
      300: "#bc9b8f",
      400: "#a87f70",
      500: "#8f6557",
      600: "#704f43",
      700: "#51382f",
      800: "#32211b",
      900: "#190703",
    },
    bluegray: {
      50: "#e6f5ff",
      100: "#ccdce5",
      200: "#b1c4cd",
      300: "#93abb7",
      400: "#7794a1",
      500: "#5e7a88",
      600: "#475f6b",
      700: "#31444d",
      800: "#192a30",
      900: "#001115",
    },
    salomie: {
      50: "#FFFFFF",
      100: "#FFFFFF",
      200: "#FFFFFF",
      300: "#FFF6DE",
      400: "#FEEAB5",
      500: "#FEDF8D",
      600: "#FECF55",
      700: "#FDC01E",
      800: "#E1A402",
      900: "#A97B01",
      950: "#8D6701",
    },
  },
})
